import React, { FC } from "react";
import styled from "styled-components";   
import { ColorModel } from "../models";

type IProps = {
  color?: ColorModel;
  heightWidth?: string;
  bgColor?: string;
  borderRadius?: string;
};
const CustomColorBox = styled.div<IProps>`
  width: ${(props) => props.heightWidth};
  height: ${(props) => props.heightWidth};
  background-color: ${(props) => props.bgColor};
  border-radius: ${(props) => props.borderRadius};
`;

const ColorBox: FC<IProps> = ({
  color,
  bgColor,
  heightWidth,
  borderRadius,
}) => {
  return (
    <CustomColorBox
      bgColor={color?.rgba || bgColor}
      borderRadius={borderRadius}
      heightWidth={heightWidth}
    />
  );
};

CustomColorBox.defaultProps = {
  heightWidth: "30px",
  bgColor: "#fff",
  borderRadius: "4px",
};

export default ColorBox;
